// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"f9b4fb88","732":"d6b44af0"}[chunkId] + ".chunk.css";
};